{
  "title": "Notifications",
  "description": "Restez informé des notifications de votre pratique.",
  "unreadCount": "({{count}} non lues)",
  "markAllRead": "Tout Marquer comme Lu",
  "markAsRead": "Marquer comme lue",
  "filterLabel": "Filtrer les notifications",
  "filter": {
    "all": "Toutes",
    "unread": "Non lues",
    "read": "Lues"
  },
  "time": {
    "justNow": "À l'instant",
    "minutesAgo": "Il y a {{count}}m",
    "hoursAgo": "Il y a {{count}}h",
    "daysAgo": "Il y a {{count}}j"
  },
  "empty": {
    "noNotifications": {
      "title": "Aucune notification pour le moment",
      "description": "Vous recevrez ici les notifications concernant les activités de votre pratique"
    },
    "noUnread": {
      "title": "Tout est à jour !",
      "description": "Vous n'avez aucune notification non lue"
    },
    "noRead": {
      "title": "Aucune notification lue",
      "description": "Les notifications lues apparaîtront ici"
    }
  },
  "errors": {
    "loadNotificationsFailed": "Échec du chargement des notifications",
    "markAsReadFailed": "Échec du marquage de la notification comme lue"
  }
}
